import { useCallback, useEffect, useRef, useState } from 'react'
import { useSetRecoilState } from 'recoil'
import classNames from 'classnames'

import { AlertData, AlertType, removeAlertQuery } from 'services/alert'

import './alert.style.css'

type Props = {
  alert: AlertData
  index: number
}

const DEFAULT_SHOW_TIME = 2500

const AlertItem = (props: Props) => {
  const { alert } = props
  const timer = useRef<NodeJS.Timeout>(null)
  const showTimer = useRef<NodeJS.Timeout>(null)
  const removeAlert = useSetRecoilState(removeAlertQuery(alert))
  const [isShowing, setIsShowing] = useState(true)

  const closeAlert = useCallback(() => {
    const duration = alert.duration || DEFAULT_SHOW_TIME

    showTimer.current = setTimeout(() => {
      setIsShowing(false)
    }, duration - 500)

    timer.current = setTimeout(() => {
      removeAlert(alert)
    }, duration)
  }, [alert, removeAlert])

  useEffect(() => {
    closeAlert()
    return () => {
      clearTimeout(timer.current)
      clearTimeout(showTimer.current)
    }
  }, [closeAlert])

  const className = classNames('alert', {
    'alert__is-hidden': !isShowing,
    alert__success: alert.type === AlertType.SUCCESS,
  })

  return (
    <div style={{ top: props.index * 90 }} className={className}>
      <span>{alert.message}</span>
    </div>
  )
}

export default AlertItem
